// extracted by mini-css-extract-plugin
module.exports = {"CreateOrderPageView":"CreateOrderPage__CreateOrderPageView___3Tt-c"};